import { makeStyles } from "@material-ui/core";

export const useTableStyles = makeStyles((theme) => ({
	materialTable: {
		"& .ag-status-bar": {
			backgroundColor: theme.palette.background.paper,
			color: theme.palette.text.primary,
			padding: theme.spacing(0.5, 1),
			fontSize: 13,
			fontWeight: "bold",
			border: "none",
		},
		height: "20.5rem",
	},
	strandTable: {
		"& .ag-header-cell-label": {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
		},
	},
	dynamicHeight: {
		height: (props?: { rowCount?: number }) => {
			const rowCount = props?.rowCount ?? 4; // Default to 4 if rowCount is not provided
			return `${Math.min(350 + (rowCount - 4) * 50, 550)}px`;
		},
		// 350px base for 4 rows, 50px for each additional row, maximum 550px (for 8 rows)
	},
	borderAgGridTable: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "10px ",
	},
	manualAutoButton: {
		minWidth: "5px",
		padding: "6px 8px",
		cursor: "auto",
	},
	// Notes
	outlinedTextarea: {
		width: "100%",
		padding: "10px 12px",
		border: `1px solid ${theme.palette.grey[400]}`,
		borderRadius: theme.shape.borderRadius,
		fontFamily: theme.typography.fontFamily,
		fontSize: theme.typography.fontSize,
		transition: theme.transitions.create(["border-color", "box-shadow"]),
		"&:hover": {
			borderColor: theme.palette.text.primary,
		},
		"&:focus": {
			borderColor: theme.palette.primary.main,
			boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
			outline: "none",
		},
		"&::placeholder": {
			color: theme.palette.text.secondary,
			opacity: 1,
		},
	},
}));

export const useManualAutoButtonStyles = makeStyles((theme) => ({
	manualAutoButton: {
		minWidth: "5px",
		width: "25px",
		height: "25px",
		padding: "6px 8px",
		cursor: "auto",
	},
}));
